import { render, staticRenderFns } from "./SendLogs.vue?vue&type=template&id=2363cfae&scoped=true"
import script from "./SendLogs.vue?vue&type=script&lang=js"
export * from "./SendLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363cfae",
  null
  
)

export default component.exports